document.addEventListener(
  "click",
  function (e) {
    // Pak je cart trigger (pas selector aan als jouw cart icon een andere class/id heeft)
    const cartTrigger = e.target.closest(
      '#cart-icon-bubble, a[href="/cart"], a[href$="/cart"], .header__icon--cart'
    );
    if (!cartTrigger) return;

    // Mobile breakpoint (pas aan indien nodig)
    if (window.matchMedia("(max-width: 989px)").matches) {
      // win van alle theme handlers (die preventDefault doen)
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = "/cart";
    }
  },
  true // capture = we gaan vóór theme listeners
);
